import "./footer.css";

function Footer() {
  return (
    <p className="footer">
      Created with ❤️{" "}
      {/* <img src="../../src/assets/react.svg" alt="" height="12em" width="auto" /> */}
    </p>
  );
}

export default Footer;
